import Button from '@allesauto/core/button';
import CircularLoader, {
  CircularLoaderType,
} from '@allesauto/core/circularLoader';
import translate from '@allesauto/i18n';
import React, { FC } from 'react';
import { IntlShape, useIntl } from 'react-intl';

import useIsCSR from '@/global/hooks/useIsCSRHook';

export interface BottomBarProps {
  onButtonClick: () => void;
  isLoading: boolean;
  currentStep?: number;
  isShoppingCartStep?: boolean;
  isDisabled?: boolean;
  trackingId?: string;
}

const BottomBar: FC<React.PropsWithChildren<BottomBarProps>> = ({
  onButtonClick,
  isLoading,
  isDisabled,
  isShoppingCartStep = false,
  trackingId,
  currentStep,
}) => {
  const intl = useIntl();
  const isClientSide = useIsCSR();

  const renderButtonLabel = (
    currentStep: number | undefined,
    isShoppingCartStep: boolean,
    intl: IntlShape
  ) => {
    const labels: { [key: number]: string } = {
      0: 'ui.CHECKOUT_SIDEBAR.TO_BILLING_ADDRESS_BTN',
      1: 'ui.CHECKOUT_SIDEBAR.TO_DELIVERY',
      2: 'ui.CHECKOUT_SIDEBAR.TO_PAYMENT_METHOD',
      3: 'ui.CHECKOUT_SIDEBAR.TO_SUMMARY',
      4: 'ui.CHECKOUT_SIDEBAR.BOTTOM_BAR_TEXT_BUTTON_CONFIRMATION',
    };

    if (
      currentStep !== undefined &&
      Object.prototype.hasOwnProperty.call(labels, currentStep)
    ) {
      return translate(intl, labels[currentStep]);
    }
    if (isShoppingCartStep) {
      return translate(intl, 'ui.SHOPPING_CART.NEXT_BUTTON');
    }
  };

  return (
    <div className="flex-col w-full">
      <Button
        customClassName="rounded-none w-full lg:py-40px h-full wl-custom-text-highlight py-20px monochrome:text-black wl-bg-highlight wl-border-highlight wl-bg-highlight--hover wl-text-highlight--hover wl-border-highlight--hover wl-btn"
        onClick={onButtonClick}
        isLoading={isLoading}
        disabled={isDisabled}
        data-tracking-id={`${trackingId}-cta`}
      >
        {isClientSide && isLoading ? (
          <CircularLoader type={CircularLoaderType.primary} />
        ) : (
          renderButtonLabel(currentStep, isShoppingCartStep, intl)
        )}
      </Button>
    </div>
  );
};

export default BottomBar;
